import React from "react";

type QuotaBarProps = {
  label: string;
  used: number;
  limit: number | null;
  unit?: string;
  formatValue?: (value: number) => string;
};

export const QuotaBar: React.FC<QuotaBarProps> = ({
  label,
  used,
  limit,
  unit = "",
  formatValue = (v) => v.toString(),
}) => {
  const isUnlimited = limit === null;
  const percentUsed = isUnlimited ? 0 : Math.min(100, (used / limit) * 100);
  const remaining = isUnlimited ? null : Math.max(0, limit - used);

  const getBarColor = () => {
    if (isUnlimited) return "bg-brand-500";
    if (percentUsed >= 90) return "bg-red-500";
    if (percentUsed >= 75) return "bg-yellow-500";
    return "bg-brand-500";
  };

  return (
    <div className="flex-1 min-w-[200px]">
      <div className="mb-1 flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </span>
        <span className="text-sm text-gray-600 dark:text-gray-400">
          {formatValue(used)}
          {isUnlimited ? (
            <span className="text-gray-500"> / Unlimited</span>
          ) : (
            <>
              <span className="text-gray-500">
                {" "}
                / {formatValue(limit)} {unit}
              </span>
            </>
          )}
        </span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
        <div
          className={`h-full rounded-full transition-all ${getBarColor()}`}
          style={{ width: isUnlimited ? "0%" : `${percentUsed}%` }}
        />
      </div>
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-500">
        {isUnlimited ? (
          "No limit"
        ) : (
          <>
            {formatValue(remaining!)} {unit} remaining ({percentUsed.toFixed(0)}
            % used)
          </>
        )}
      </div>
    </div>
  );
};
